import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ContractService } from '../../services/contract.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';

@Component({
  selector: 'app-contract-validate-modal',
  templateUrl: './contract-validate-modal.component.html',
  styleUrl: './contract-validate-modal.component.scss',
  providers: [DialogService],
})
export class ContractValidateModalComponent {
  @Input() visible: boolean = false;
  @Input() dataToView: any | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() updateStateComplete = new EventEmitter<void>();

  showButtons: boolean = true;
  showConfirmation: boolean = true;
  showTextarea: boolean = true;
  primaryButtonLabel: string = 'PENDIENTE DE FIRMA';
  userData: any = null;
  isRejected: boolean = false;

  currentFile: File | null = null;
  selectedFileName: string | null = null;
  @ViewChild('pdfUploader') pdfUploader: any;

  viewDocument: string = '';
  originalFileName: string | null = null;

  steps = [
    { label: 'Enviado', key: 1 },
    { label: 'Pendiente', key: 2 },
    { label: 'Aprobado', key: 3 },
    { label: '', key: 4 },
  ];

  getStepLabel(index: number, status: string): string {
    if (status === 'rechazado' && index === 1) {
      // Estado 2 (Enviado) cuando es rechazado
      return 'Rechazado';
    }
    if (status === 'aprobado' && index === 3) {
      return 'Aprobado';
    }
    return this.steps[index].label;
  }

  get visibleSteps() {
    if (this.status === 'aprobado') {
      return this.steps.slice(0, 4); // Muestra solo los primeros 3 labels
    }
    if (this.status === 'rechazado') {
      return this.steps.slice(0, 4);
    }
    return this.steps;
  }

  currentStep = 1;
  status: 'pendiente' | 'aprobado' | 'no renovado' | 'rechazado' = 'pendiente';

  stateContract = {
    stateContractId: 1,
    stateContractName: 'En evaluación',
  };

  isLoading: boolean = false;
  dateStart: Date = new Date();
  dateEnd: Date = new Date();
    collaborator: string = '';
  amount: string = '';
  currencyId: number = 0;

  hasInteracted: { [key: string]: boolean } = {
    currentFile: false,
    stateContract: false,
    selectedFileName: false,
  };

  constructor(
    private contractService: ContractService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }
  }

  ngOnChanges(): void {
    if (this.visible && this.dataToView) {
      this.currentFile = null;
      this.selectedFileName = null;
      this.originalFileName = null;
      this.viewDocument = '';
      this.pdfUploader?.clear();
      this.isLoading = true;
      console.log('this.dataToView', this.dataToView);
      const contractId = this.dataToView.contractId;

      this.contractService.getContractByContractId(contractId).subscribe({
        next: (contract) => {
          this.stateContract = {
            stateContractId: contract.stateContractId,
            stateContractName: contract.stateContractName,
          };
          this.updateState(contract.stateContractId);
          this.collaborator = this.dataToView?.employeeName;
          this.dateStart = contract.startDateContract;
          this.dateEnd = contract.endDate;

          this.originalFileName = contract.fileContract
            ? this.extractFileName(contract.fileContract)
            : null;

          this.viewDocument = contract?.fileContract;

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error al cargar los datos del empleado:', err);
        },
      });
    }
  }

  updateState(stateId: number): void {
    this.showButtons = false;
    switch (stateId) {
      case 4: // Pendiente de envío
        this.currentStep = 1;
        this.status = 'pendiente';
        this.stateContract = {
          stateContractId: 1,
          stateContractName: 'Pendiente de envío',
        };
        this.primaryButtonLabel = 'FIRMAR DOCUMENTO';
        this.showButtons = false; // No mostrar botón hasta que esté en estado 2
        break;

      case 2: // Enviado
        this.currentStep = 2;
        this.status = 'pendiente';
        this.stateContract = {
          stateContractId: 2,
          stateContractName: 'Enviado',
        };
        this.primaryButtonLabel = 'ENVIAR';
        this.showButtons = true; // Mostrar botón para firmar
        break;

      case 3: // Firmado
        this.currentStep = 4;
        this.status = 'aprobado';
        this.stateContract = {
          stateContractId: 4,
          stateContractName: 'Firmado',
        };
        this.showButtons = false;
        break;

      case 5: // Firmado (aprobado)
        this.currentStep = 2;
        this.status = 'pendiente';
        this.stateContract = {
          stateContractId: 5,
          stateContractName: 'Pendiente de Firma',
        };
        this.primaryButtonLabel = 'ENVIAR';
        this.showButtons = true;
        break;

        // case 6: // Firmado (aprobado)
        // this.currentStep = 4;
        // this.status = 'aprobado';
        // this.stateContract = {
        //   stateContractId: 4,
        //   stateContractName: 'Firmado y validado',
        // };
        // this.showButtons = false;
        // break;

      default:
        console.warn('Estado no manejado:', stateId);
    }
  }
  validateForm(): boolean {
    return !this.currentFile;
  }

  onButtonClick() {
    this.closeDialog();
  }

  onPrimaryButtonClick(): void {
    if (this.validateForm()) {
      return;
    }
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    let stateId: number;
    let title: string;

    const request = {
      stateContractId: 6, // Cambiar a Pendiente de validación
      userId: this.userData.employeeId,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    appendIfDefined('stateContractId', request.stateContractId);
    appendIfDefined('userId', request.userId);

    if (this.currentFile) {
      appendIfDefined('file', this.currentFile);
    }

    this.contractService.updateChangeStateContract(this.dataToView.contractId, formData)
      .subscribe({
        next: (response) => {
          loadingRef.close();
          this.closeDialog();
          const ref = this.dialogService.open(ModalSuccessComponent, {
            header: '',
            data: {
              text: 'Documento firmado y enviado para validación',
              title: '¡Documento firmado!',
              icon: 'pi pi-check-circle',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.updateStateComplete.emit();
        },
        error: (err) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          console.error('Error al actualizar el estado:', err);
        },
      });
    this.closeDialog();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'copy';
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0];

      if (this.isValidFile(droppedFile)) {
        this.currentFile = droppedFile;
        this.selectedFileName = droppedFile.name;
      } else {
        this.currentFile = null;
        this.selectedFileName = null;

        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF de hasta 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
      }
    }
  }

  isValidFile(file: File): boolean {
    const maxSize = 10_000_000;

    if (file.type !== 'application/pdf') {
      console.log('Tipo de archivo no permitido:', file.type);
      return false;
    }

    if (file.size > maxSize) {
      console.log('Archivo demasiado grande:', file.size);
      return false;
    }

    return true;
  }

  openFileUpload(type: string) {
    if (type === 'pdf' && this.pdfUploader) {
      this.pdfUploader.choose();
    } else {
      console.error('El fileUploader no está disponible.');
    }
  }

  onChangeFile(event: any) {
    const selectedFile = event.files[0];
    if (selectedFile) {
      const maxSize = 10_000_000;
      const allowedTypes = ['application/pdf'];

      if (!allowedTypes.includes(selectedFile.type)) {
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.currentFile = null;
        this.selectedFileName = null;
        this.hasInteracted['currentFile'] = false;
        this.validateForm();
        return;
      }

      if (selectedFile.size > maxSize) {
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo es demasiado grande. El tamaño máximo permitido es de 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.currentFile = null;
        this.selectedFileName = null;
        this.hasInteracted['currentFile'] = false;
        this.validateForm();
        return;
      }

      this.currentFile = selectedFile;
      this.selectedFileName = selectedFile.name;
      this.hasInteracted['currentFile'] = false;
      this.validateForm();
    }
    this.validateForm();
  }

  downloadFile() {
    if (this.viewDocument) {
      window.open(this.viewDocument, '_blank', 'noopener,noreferrer');
    }
  }

  removeFile(): void {
    this.currentFile = null;
    this.selectedFileName = null;
    this.pdfUploader?.clear();
  }

  extractFileName(fileUrl: string): string {
    const lastDashIndex = fileUrl.lastIndexOf('-', fileUrl.lastIndexOf('.'));
    const fileName = fileUrl.substring(lastDashIndex + 1);
    return fileName;
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
